import React from "react";
import { useTranslation } from "react-i18next";
import { TextDescription, TextTitle } from "components/Texts";

import Row from "components/Row";
import Column from "components/Column";
import Icon from "components/Icon";
import Separator from "components/Separator";
import colors from "styles/colors";
import CampaignZone from "./CampaignZone";
import KeywordZone from "./KeywordZone";

const NoTrackingData = ({ name }) => {
  const [t] = useTranslation();
  let icon, title, example;
  if (name === "opportunity") {
    icon = "icon-trending";
    title = t("__opportunity");
    example = (
      <CampaignZone
        data={[
          {
            campaign: "Campaign A",
            dailyCost: 1000,
            budgetOpportunity: 2000,
            clicks: 20,
            moreClick: 10,
          },
        ]}
        example
      />
    );
  } else {
    icon = "icon-sms-failed";
    title = t("__low_performance_keyword");
    example = (
      <KeywordZone
        data={[
          {
            keyword: "Keyword A",
            campaign: "Campaign B",
            campaign_avg_cpa: 50,
            avg_cpa: 100,
          },
        ]}
        example
      />
    );
  }

  return (
    <>
      <Row columnSpacing="8px">
        <Column wrap>
          <Icon name={icon} size="26px" color={colors.primary} />
        </Column>
        <Column>
          <TextTitle>{title}</TextTitle>
          <Separator />
          <TextTitle color={colors.descriptionText}>{t("__no_tracking_data")}</TextTitle>
          <TextDescription>{t("__no_tracking_data_desc")}</TextDescription>
        </Column>
      </Row>
      <Separator />
      {example}
    </>
  );
};

export default NoTrackingData;
